<template>
    <div class="specialisms mb-2" v-if="(typeof(tyre) != 'undefined')">
        <span
            v-for="badge in specialismBadges"
            class="badge bg-navy"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="badge.description"
        >
            <b>{{ badge.name }}</b>
        </span>
    </div>
</template>

<script>
    export default {
        props: ['tyre'],
        data() {
            return {
                
            }
        },
        methods: {

        },
        computed: {
            specialismBadges() {
                let badges = [];

                if(this.tyre?.electric == 1 || this.tyre?.electric_type) {
                    badges.push({name: 'EV/HEV', description: 'These tyres are suitable for Electric/Hybrid Vehicles. They have the perfect balance between low rolling distance, grip and sturdiness.'});
                }
                if(this.tyre?.season.includes('All Season')) {
                    badges.push({name: 'All Season', description: 'All season tyres, also known as “All Weather tyres” are suitable for all weather conditions.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'caravan') {
                    badges.push({name: 'Caravan', description: 'These tyres are designed specifically for caravans to support the extra weight. The reinforced sidewall makes them more durable than an average tyre.'});
                }
                if(this.tyre?.rft == 1 && _lowerCase(this.tyre.rft_type) != 'ext') {
                    badges.push({name: 'RFT', description: 'Run flat tyres are able to perform safely with no air pressure for a limited time period. This is to ensure you can make it to a nearby garage to have the issue resolved.'});
                }
                if(_lowerCase(this.tyre?.rft_type) == 'ext') {
                    badges.push({name: 'EXT', description: 'EXT tyres have been developed by Bridgestone and Mercedes for specific run flat tyres for Mercedes vehicles.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'driveguard') {
                    badges.push({name: 'DG', description: 'DriveGuard technology is developed by Bridgestone. DriveGuard allows you to maintain control after a puncture and safely continue driving for 50 miles at up to 50mph, giving you chance to repair or replace your tyre at a more convenient time.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'ssr' || (this.tyre?.ssr)) {
                    badges.push({name: 'SSR', description: 'SSR (Self Supporting Runflat) are compatible with all standard rims. SSR are made by Continental and allow you to drive for 50 miles at up to 50mph if you have a puncture. Giving you more time to go to a nearby garage.'});
                }
                if(this.tyre?.season.includes('Summer')) {
                    badges.push({name: 'Summer', description: 'Summer tyres are designed for temperatures above 7°C. Due to their specially designed compound, they have improved handling during warmer temperatures in both wet and dry conditions.'});
                }
                if((this.tyre?.seal == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contiseal) {
                    badges.push({name: 'Seal', description: 'ContiSeal tyres will keep you moving by immediately sealing punctures up to 5mm in diameter (such as a nail). This will ensure you\'re able to get the issue resolved at a more convenient time.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contisilent) {
                    badges.push({name: 'Silent', description: 'ContiSilent tyres perform the same as a normal tyre, but they reduce noise on all road surfaces and in all weather.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'bridgestone')) {
                    badges.push({name: 'Silent', description: 'B-Silent technology by Bridgestone lowers the volume of vehicle noise and road vibrations with sound-absorbing foam withing the tyre itself.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'dunlop')) {
                    badges.push({name: 'Silent', description: 'Noise Shield technology by Dunlop reduces noise levels in the interior by 50% with no compromise on performance potentialities.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'goodyear')) {
                    badges.push({name: 'Silent', description: 'SoundComfortTechnology by Goodyear reduce vibrations in the air and lower the noise levels within the vehicle to provide a smoother ride for you and your passengers.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'hankook')) {
                    badges.push({name: 'Silent', description: 'SoundAbsorber tyres by Hankook provide high-comfort to you and your passengers whilst reducing the noise levels by as much as 5 to 7 decibels.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'michelin')) {
                    badges.push({name: 'Silent', description: 'Acoustic Technology by Michelin provide a relaxing and quiet ride by reducing road vibrations and interior noise by 20%'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'pirelli')) {
                    badges.push({name: 'Silent', description: 'PNCS by Pirelli are noise-cancelling tyres, they absorb vibrations within the walls of the tyres by 2 to 3 decibels with no compromise on comfort.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'trailer') {
                    badges.push({name: 'Trailer', description: 'These tyres have a reinforced sidewall to make them suitable for extra weight. They tend to have minimum tread to accommodate the movement of the trailer.'});
                }
                if(this.tyre.vehicle_type == 'Commercial Van') {
                    badges.push({name: 'Van', description: 'These tyres are designed specifically for vans, providing extra durability to cope with the extra weight and tough conditions.'});
                }
                if(this.tyre?.season.includes('Winter')) {
                    badges.push({name: 'Winter', description: 'Winter tyres are designed for temperatures below 7°C. Due to their specially designed compound, they have improved handling in the colder temperatures. Some have studs to improve grip on snow and ice.'});
                }
                if(this.tyre?.xl == 'XL') {
                    badges.push({name: 'XL', description: 'Extra Load tyres are designed to carrier heavier loads, they are the same as normal tyres, but with reinforced sidewalls. If you already have XL tyres factory fitted to your vehicle, you would need to stick with XL tyres.'});
                }
                if(this.tyre?.vehicle_type == 'Passenger 4x4') {
                    badges.push({name: '4x4', description: '4x4\'s require special tyres to ensure wear throughout the lifetime of the tyre and to provide sufficient performance off-road.'});
                }
                if(this.tyre?.three_peaks == 1) {
                    badges.push({name: '3PMSF', description: 'For winter tyres, the 3PMSF symbol is an assurance of reliability and safety in snow. This marking is earned through testing in accordance with standardised regulatory methods, with certification awarded by a recognised laboratory.'});
                }
                if(this.tyre?.ice_grip == 1) {
                    badges.push({name: 'M+S', description: 'Mud and snow (M+S) winter tyres are tailored for optimal performance in snowy or muddy road conditions, surpassing standard models like summer tyres. It\'s important to be aware that the M+S marking is subject to the manufacturer\'s decision and doesn\'t require passing a certified test.'});
                }

                return badges;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .specialisms {
        span {
            cursor: default;
            &:not(:last-of-type) {
                margin-right: 0.2rem !important;
            }
            b {
                font-weight: 500;
                font-size: 12px;
                text-transform: uppercase;
                color: #fff;
            }
        };
    }
</style>